/* eslint-disable */
const S4 = () =>
  (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isValidUuid = (value) =>
  typeof value === 'string' && UUID_REGEX.test(value);

export default () =>
  (
    S4() +
    S4() +
    '-' +
    S4() +
    '-4' +
    S4().substr(0, 3) +
    '-' +
    S4() +
    '-' +
    S4() +
    S4() +
    S4()
  ).toLowerCase();
